export interface Country {
  country: string
  callingCode: string
}

export default [
  { country: 'CU', callingCode: '53' },
  { country: 'US', callingCode: '1' },
  { country: 'AD', callingCode: '376' },
  { country: 'AE', callingCode: '971' },
  { country: 'AF', callingCode: '93' },
  { country: 'AG', callingCode: '1' },
  { country: 'AI', callingCode: '1' },
  { country: 'AL', callingCode: '355' },
  { country: 'AM', callingCode: '374' },
  { country: 'AO', callingCode: '244' },
  { country: 'AR', callingCode: '54' },
  { country: 'AS', callingCode: '1' },
  { country: 'AT', callingCode: '43' },
  { country: 'AU', callingCode: '61' },
  { country: 'AW', callingCode: '297' },
  { country: 'AX', callingCode: '358' },
  { country: 'AZ', callingCode: '994' },
  { country: 'BA', callingCode: '387' },
  { country: 'BB', callingCode: '1' },
  { country: 'BD', callingCode: '880' },
  { country: 'BE', callingCode: '32' },
  { country: 'BF', callingCode: '226' },
  { country: 'BG', callingCode: '359' },
  { country: 'BH', callingCode: '973' },
  { country: 'BI', callingCode: '257' },
  { country: 'BJ', callingCode: '229' },
  { country: 'BL', callingCode: '590' },
  { country: 'BM', callingCode: '1' },
  { country: 'BN', callingCode: '673' },
  { country: 'BO', callingCode: '591' },
  { country: 'BQ', callingCode: '599' },
  { country: 'BR', callingCode: '55' },
  { country: 'BS', callingCode: '1' },
  { country: 'BT', callingCode: '975' },
  { country: 'BW', callingCode: '267' },
  { country: 'BY', callingCode: '375' },
  { country: 'BZ', callingCode: '501' },
  { country: 'CA', callingCode: '1' },
  { country: 'CC', callingCode: '61' },
  { country: 'CD', callingCode: '243' },
  { country: 'CF', callingCode: '236' },
  { country: 'CG', callingCode: '242' },
  { country: 'CH', callingCode: '41' },
  { country: 'CI', callingCode: '225' },
  { country: 'CK', callingCode: '682' },
  { country: 'CL', callingCode: '56' },
  { country: 'CM', callingCode: '237' },
  { country: 'CN', callingCode: '86' },
  { country: 'CO', callingCode: '57' },
  { country: 'CR', callingCode: '506' },
  { country: 'CV', callingCode: '238' },
  { country: 'CW', callingCode: '599' },
  { country: 'CX', callingCode: '61' },
  { country: 'CY', callingCode: '357' },
  { country: 'CZ', callingCode: '420' },
  { country: 'DE', callingCode: '49' },
  { country: 'DJ', callingCode: '253' },
  { country: 'DK', callingCode: '45' },
  { country: 'DM', callingCode: '1' },
  { country: 'DO', callingCode: '1' },
  { country: 'DZ', callingCode: '213' },
  { country: 'EC', callingCode: '593' },
  { country: 'EE', callingCode: '372' },
  { country: 'EG', callingCode: '20' },
  { country: 'EH', callingCode: '212' },
  { country: 'ER', callingCode: '291' },
  { country: 'ES', callingCode: '34' },
  { country: 'ET', callingCode: '251' },
  { country: 'FI', callingCode: '358' },
  { country: 'FJ', callingCode: '679' },
  { country: 'FK', callingCode: '500' },
  { country: 'FM', callingCode: '691' },
  { country: 'FO', callingCode: '298' },
  { country: 'FR', callingCode: '33' },
  { country: 'GA', callingCode: '241' },
  { country: 'GB', callingCode: '44' },
  { country: 'GD', callingCode: '1' },
  { country: 'GE', callingCode: '995' },
  { country: 'GF', callingCode: '594' },
  { country: 'GG', callingCode: '44' },
  { country: 'GH', callingCode: '233' },
  { country: 'GI', callingCode: '350' },
  { country: 'GL', callingCode: '299' },
  { country: 'GM', callingCode: '220' },
  { country: 'GN', callingCode: '224' },
  { country: 'GP', callingCode: '590' },
  { country: 'GQ', callingCode: '240' },
  { country: 'GR', callingCode: '30' },
  { country: 'GT', callingCode: '502' },
  { country: 'GU', callingCode: '1' },
  { country: 'GW', callingCode: '245' },
  { country: 'GY', callingCode: '592' },
  { country: 'HK', callingCode: '852' },
  { country: 'HN', callingCode: '504' },
  { country: 'HR', callingCode: '385' },
  { country: 'HT', callingCode: '509' },
  { country: 'HU', callingCode: '36' },
  { country: 'ID', callingCode: '62' },
  { country: 'IE', callingCode: '353' },
  { country: 'IL', callingCode: '972' },
  { country: 'IM', callingCode: '44' },
  { country: 'IN', callingCode: '91' },
  { country: 'IO', callingCode: '246' },
  { country: 'IQ', callingCode: '964' },
  { country: 'IR', callingCode: '98' },
  { country: 'IS', callingCode: '354' },
  { country: 'IT', callingCode: '39' },
  { country: 'JE', callingCode: '44' },
  { country: 'JM', callingCode: '1' },
  { country: 'JO', callingCode: '962' },
  { country: 'JP', callingCode: '81' },
  { country: 'KE', callingCode: '254' },
  { country: 'KG', callingCode: '996' },
  { country: 'KH', callingCode: '855' },
  { country: 'KI', callingCode: '686' },
  { country: 'KM', callingCode: '269' },
  { country: 'KN', callingCode: '1' },
  { country: 'KP', callingCode: '850' },
  { country: 'KR', callingCode: '82' },
  { country: 'KW', callingCode: '965' },
  { country: 'KY', callingCode: '1' },
  { country: 'KZ', callingCode: '7' },
  { country: 'LA', callingCode: '856' },
  { country: 'LB', callingCode: '961' },
  { country: 'LC', callingCode: '1' },
  { country: 'LI', callingCode: '423' },
  { country: 'LK', callingCode: '94' },
  { country: 'LR', callingCode: '231' },
  { country: 'LS', callingCode: '266' },
  { country: 'LT', callingCode: '370' },
  { country: 'LU', callingCode: '352' },
  { country: 'LV', callingCode: '371' },
  { country: 'LY', callingCode: '218' },
  { country: 'MA', callingCode: '212' },
  { country: 'MC', callingCode: '377' },
  { country: 'MD', callingCode: '373' },
  { country: 'ME', callingCode: '382' },
  { country: 'MF', callingCode: '590' },
  { country: 'MG', callingCode: '261' },
  { country: 'MH', callingCode: '692' },
  { country: 'MK', callingCode: '389' },
  { country: 'ML', callingCode: '223' },
  { country: 'MM', callingCode: '95' },
  { country: 'MN', callingCode: '976' },
  { country: 'MO', callingCode: '853' },
  { country: 'MP', callingCode: '1' },
  { country: 'MQ', callingCode: '596' },
  { country: 'MR', callingCode: '222' },
  { country: 'MS', callingCode: '1' },
  { country: 'MT', callingCode: '356' },
  { country: 'MU', callingCode: '230' },
  { country: 'MV', callingCode: '960' },
  { country: 'MW', callingCode: '265' },
  { country: 'MX', callingCode: '52' },
  { country: 'MY', callingCode: '60' },
  { country: 'MZ', callingCode: '258' },
  { country: 'NA', callingCode: '264' },
  { country: 'NC', callingCode: '687' },
  { country: 'NE', callingCode: '227' },
  { country: 'NF', callingCode: '672' },
  { country: 'NG', callingCode: '234' },
  { country: 'NI', callingCode: '505' },
  { country: 'NL', callingCode: '31' },
  { country: 'NO', callingCode: '47' },
  { country: 'NP', callingCode: '977' },
  { country: 'NR', callingCode: '674' },
  { country: 'NU', callingCode: '683' },
  { country: 'NZ', callingCode: '64' },
  { country: 'OM', callingCode: '968' },
  { country: 'PA', callingCode: '507' },
  { country: 'PE', callingCode: '51' },
  { country: 'PF', callingCode: '689' },
  { country: 'PG', callingCode: '675' },
  { country: 'PH', callingCode: '63' },
  { country: 'PK', callingCode: '92' },
  { country: 'PL', callingCode: '48' },
  { country: 'PM', callingCode: '508' },
  { country: 'PR', callingCode: '1' },
  { country: 'PS', callingCode: '970' },
  { country: 'PT', callingCode: '351' },
  { country: 'PW', callingCode: '680' },
  { country: 'PY', callingCode: '595' },
  { country: 'QA', callingCode: '974' },
  { country: 'RE', callingCode: '262' },
  { country: 'RO', callingCode: '40' },
  { country: 'RS', callingCode: '381' },
  { country: 'RU', callingCode: '7' },
  { country: 'RW', callingCode: '250' },
  { country: 'SA', callingCode: '966' },
  { country: 'SB', callingCode: '677' },
  { country: 'SC', callingCode: '248' },
  { country: 'SD', callingCode: '249' },
  { country: 'SE', callingCode: '46' },
  { country: 'SG', callingCode: '65' },
  { country: 'SH', callingCode: '290' },
  { country: 'SI', callingCode: '386' },
  { country: 'SJ', callingCode: '47' },
  { country: 'SK', callingCode: '421' },
  { country: 'SL', callingCode: '232' },
  { country: 'SM', callingCode: '378' },
  { country: 'SN', callingCode: '221' },
  { country: 'SO', callingCode: '252' },
  { country: 'SR', callingCode: '597' },
  { country: 'SS', callingCode: '211' },
  { country: 'ST', callingCode: '239' },
  { country: 'SV', callingCode: '503' },
  { country: 'SX', callingCode: '1' },
  { country: 'SY', callingCode: '963' },
  { country: 'SZ', callingCode: '268' },
  { country: 'TA', callingCode: '290' },
  { country: 'TC', callingCode: '1' },
  { country: 'TD', callingCode: '235' },
  { country: 'TG', callingCode: '228' },
  { country: 'TH', callingCode: '66' },
  { country: 'TJ', callingCode: '992' },
  { country: 'TK', callingCode: '690' },
  { country: 'TL', callingCode: '670' },
  { country: 'TM', callingCode: '993' },
  { country: 'TN', callingCode: '216' },
  { country: 'TO', callingCode: '676' },
  { country: 'TR', callingCode: '90' },
  { country: 'TT', callingCode: '1' },
  { country: 'TV', callingCode: '688' },
  { country: 'TW', callingCode: '886' },
  { country: 'TZ', callingCode: '255' },
  { country: 'UA', callingCode: '380' },
  { country: 'UG', callingCode: '256' },
  { country: 'UY', callingCode: '598' },
  { country: 'UZ', callingCode: '998' },
  { country: 'VA', callingCode: '39' },
  { country: 'VC', callingCode: '1' },
  { country: 'VE', callingCode: '58' },
  { country: 'VG', callingCode: '1' },
  { country: 'VI', callingCode: '1' },
  { country: 'VN', callingCode: '84' },
  { country: 'VU', callingCode: '678' },
  { country: 'WF', callingCode: '681' },
  { country: 'WS', callingCode: '685' },
  { country: 'XK', callingCode: '383' },
  { country: 'YE', callingCode: '967' },
  { country: 'YT', callingCode: '262' },
  { country: 'ZA', callingCode: '27' },
  { country: 'ZM', callingCode: '260' },
  { country: 'ZW', callingCode: '263' },
  { country: 'AC', callingCode: '247' },
]
